
import React from 'react';
import styled from 'styled-components';
import MobileImage from '../../assets/blob_top_mobile.png';
import TabletImage from '../../assets/blob_top_tablet.png';
import DesktopImage from '../../assets/blob_top_1440.png';
import { useBreakpoint } from '../../styles';

const BlobImage = styled.img`
    position: absolute;
    width: 100%;
    left: 0px;
    right: 0px;
    top: 0px;
    max-width: 1440px;
    margin-left:auto;
    margin-right:auto;
    z-index: -1;
}`;

const Blob = () => {

    let breakpoint = useBreakpoint();
    if(['xs', 'mobile'].includes(breakpoint)) {
        return (<BlobImage
            src={MobileImage} />);
    }
    if(['sm', 'md'].includes(breakpoint)) {
        return (<BlobImage
            src={TabletImage} />);
    }

    return (<BlobImage
        src={DesktopImage} />);
};

export default Blob;